// extracted by mini-css-extract-plugin
export default {"footerFixed":"Checkout_footerFixed__Z882h"};